import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Card, Button, Form, Alert, Badge, Spinner } from "react-bootstrap";
import Select from 'react-select';
import { alterarConfiguracao, pegarClinicaConfiguracao, pegarConfiguracao, salvarConfiguracao } from "../data/api/gsConnectApi";
import { fileToBase64 } from "../utils/utils";
import { useHistory } from 'react-router-dom';

function MensagensView() {
  const [mensagemSucesso, setMensagemSucesso] = useState('');
  const [mensagemErro, setMensagemErro] = useState('');

  const showSuccess = (message) => {
    setMensagemSucesso(message);
    setTimeout(() => setMensagemSucesso(''), 3000);
  };

  const showError = (message) => {
    setMensagemErro(message);
    setTimeout(() => setMensagemErro(''), 5000);
  };

  const history = useHistory();

  return (
    <div style={{backgroundColor: '#f8f9fa', minHeight: '100vh'}}>
      {/* Header seguindo padrão */}
      <div style={{backgroundColor: '#198754', color: 'white', padding: '12px 20px', fontSize: '16px', fontWeight: '500'}}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <Button variant="outline-light" size="sm" style={{borderColor: 'white', color: 'white', marginRight: 12}} onClick={() => history.push('/admin/home')}>
              ← Voltar
            </Button>
            <span>Mensagens</span>
          </div>
          <Badge bg="primary" className="px-3 py-2">Configurações</Badge>
        </div>
      </div>

      <Container fluid className="p-3">
        {/* Alerts */}
        {mensagemSucesso && (
          <Alert variant="success" className="mb-3" dismissible onClose={() => setMensagemSucesso('')}>
            ✅ {mensagemSucesso}
          </Alert>
        )}
        {mensagemErro && (
          <Alert variant="danger" className="mb-3" dismissible onClose={() => setMensagemErro('')}>
            ❌ {mensagemErro}
          </Alert>
        )}

        {/* Card de Dicas */}
        <div className="bg-white p-3 mb-3" style={{border: '1px solid #dee2e6'}}>
          <h5 className="mb-3" style={{color: '#198754', fontWeight: '600'}}>💡 Dicas de Formatação</h5>
          <Row className="mb-2">
            <Col><small><strong>1 - Negrito:</strong> Use *TEXTO* para formatar em negrito. Ex: Olá *PacienteTeste* → Olá <strong>PacienteTeste</strong></small></Col>
          </Row>
          <Row className="mb-2">
            <Col><small><strong>2 - Itálico:</strong> Use _TEXTO_ para formatar em itálico. Ex: Olá _PacienteTeste_ → Olá <em>PacienteTeste</em></small></Col>
          </Row>
          <Row className="mb-2">
            <Col><small><strong>3 - Tachado:</strong> Use ~TEXTO~ para tachar o texto. Ex: Olá ~PacienteTeste~ → Olá <span style={{textDecoration: 'line-through'}}>PacienteTeste</span></small></Col>
          </Row>
        </div>

        {/* Configurações */}
        <ConfiguracaoSecao 
          titulo="Confirmação de agendamento" 
          tipo="InstanciaMensagemConfirmacaoAgendamento"
          variaveis={['$nomePaciente', '$nomeProcedimento', '$nomeMedico', '$nomeDiaDaSemana', '$dataAgendamento', '$horarioAgendamento', '$link']}
          configs={[
            {titulo: 'Mensagem ao enviar a confirmação de agendamento', tipo: 'MensagemConfirmaçãoAgendamento'},
            {titulo: 'Mensagem ao confirmar o agendamento', tipo: 'MensagemConfirmaçãoAgendamentoAoConfirmar'},
            {titulo: 'Mensagem ao cancelar o agendamento', tipo: 'MensagemConfirmaçãoAgendamentoAoCancelar'}
          ]}
          onSuccess={showSuccess}
          onError={showError}
        />

        <ConfiguracaoSecao 
          titulo="Pré cadastro" 
          tipo="InstanciaMensagemPreCadastro"
          variaveis={['$nomePaciente', '$link', '$dataValidadeLink']}
          configs={[
            {titulo: 'Mensagem ao enviar o pré cadastro', tipo: 'MensagemPreCadastro'}
          ]}
          onSuccess={showSuccess}
          onError={showError}
        />

        <ConfiguracaoSecao 
          titulo="Pré consulta" 
          tipo="InstanciaMensagemPreConsulta"
          variaveis={['$nomePaciente', '$link', '$dataValidadeLink']}
          configs={[
            {titulo: 'Mensagem ao enviar a pré consulta', tipo: 'MensagemPreConsulta'}
          ]}
          onSuccess={showSuccess}
          onError={showError}
        />

        <ConfiguracaoSecao 
          titulo="Lembrete de agendamento" 
          tipo="InstanciaMensagemLembreteAgendamento"
          variaveis={['$nomePaciente', '$nomeProcedimento', '$nomeMedico', '$nomeDiaDaSemana', '$dataAgendamento', '$horarioAgendamento', '$link']}
          configs={[
            {titulo: 'Mensagem ao enviar o lembrete de agendamento', tipo: 'MensagemLembreteAgendamento'}
          ]}
          onSuccess={showSuccess}
          onError={showError}
        />

        <ConfiguracaoSecao 
          titulo="Questionário" 
          tipo="InstanciaMensagemQuestionario"
          variaveis={['$nomePaciente', '$nomeQuestionario', '$link']}
          configs={[
            {titulo: 'Mensagem ao enviar o questionário', tipo: 'MensagemQuestionario'}
          ]}
          onSuccess={showSuccess}
          onError={showError}
        />

        <ConfiguracaoSecao 
          titulo="Cobrança de congelados" 
          tipo="InstanciaMensagemCobrancaCongelados"
          variaveis={['$nome', '$nomeConjuge', '$tipoMaterial', '$dataCongelamento', '$nomeMedico', '$dataVencimento', '$valorASerPago']}
          configs={[
            {titulo: 'Mensagem de cobrança de congelados', tipo: 'MensagemCobrancaCongelados'}
          ]}
          onSuccess={showSuccess}
          onError={showError}
        />

        <ConfiguracaoAniversario onSuccess={showSuccess} onError={showError} />

        {['Texto', 'Pdf', 'Resumo de ciclo', 'Laudo Espermograma', 'GED (Anexos)', 'Nota Fiscal'].map((titulo, index) => (
          <ConfiguracaoSecaoSimples 
            key={index}
            titulo={titulo} 
            tipo={`InstanciaMensagem${titulo.replace(/\s+/g, '').replace(/[()]/g, '')}`}
            onSuccess={showSuccess}
            onError={showError}
          />
        ))}

        <ConfiguracaoSecaoSimples 
          key="gatilho"
          titulo="Gatilho" 
          tipo="InstanciaMensagemGatilho"
          onSuccess={showSuccess}
          onError={showError}
        />
      </Container>
    </div>
  );
}

// Componente para seções com configurações
const ConfiguracaoSecao = ({ titulo, tipo, variaveis, configs, onSuccess, onError }) => {
  return (
    <div className="bg-white mb-3" style={{border: '1px solid #dee2e6'}}>
      <div style={{backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6'}}>
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0" style={{color: '#495057', fontWeight: '600'}}>{titulo}</h6>
          <SelecionarWhatsapp tipo={tipo} onSuccess={onSuccess} onError={onError} />
        </div>
      </div>
      <div className="p-3">
        {variaveis && (
          <div className="mb-3">
            <small className="text-muted d-block mb-2"><strong>Variáveis disponíveis:</strong></small>
            <div className="d-flex flex-wrap gap-1">
              {variaveis.map((variavel, index) => (
                <Badge key={index} bg="light" text="dark" className="small">{variavel}</Badge>
              ))}
            </div>
          </div>
        )}
        {configs.map((config, index) => (
          <ConfiguracaoItem 
            key={index}
            titulo={config.titulo} 
            tipo={config.tipo}
            onSuccess={onSuccess}
            onError={onError}
          />
        ))}
      </div>
    </div>
  );
};

// Componente para seções simples
const ConfiguracaoSecaoSimples = ({ titulo, tipo, onSuccess, onError }) => {
  return (
    <div className="bg-white mb-3" style={{border: '1px solid #dee2e6'}}>
      <div style={{backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6'}}>
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0" style={{color: '#495057', fontWeight: '600'}}>{titulo}</h6>
          <SelecionarWhatsapp tipo={tipo} onSuccess={onSuccess} onError={onError} />
        </div>
      </div>
    </div>
  );
};

// Componente para configuração de aniversário
const ConfiguracaoAniversario = ({ onSuccess, onError }) => {
  const [tipo, setTipo] = useState('Texto');
  const [textoConfiguracao, setTextoConfiguracao] = useState('');
  const [imagemConfiguracao, setImagemConfiguracao] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    pegarClinicaConfiguracao('MensagemAniversario').then((json) => {
      if (json && json.valor) {
        if (json.valor.includes('data:image')) {
          setImagemConfiguracao(json.valor);
          setTipo('Imagem');
        } else {
          setTextoConfiguracao(json.valor);
          setTipo('Texto');
        }
      }
    }).catch(error => {
      console.error('Erro ao carregar configuração:', error);
    });
  }, []);

  const handleSalvar = async () => {
    setLoading(true);
    try {
      const configuracao = tipo === 'Texto' ? textoConfiguracao : imagemConfiguracao;
      await salvarConfiguracao('MensagemAniversario', configuracao);
      onSuccess('Configuração de aniversário salva com sucesso!');
    } catch (error) {
      onError('Erro ao salvar configuração de aniversário.');
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (event) => {
    if (event.target.files.length > 0) {
      try {
        const arquivoBase64 = await fileToBase64(event.target.files[0]);
        setImagemConfiguracao(arquivoBase64);
      } catch (error) {
        onError('Erro ao processar imagem.');
      }
    }
  };

  return (
    <div className="bg-white mb-3" style={{border: '1px solid #dee2e6'}}>
      <div style={{backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6'}}>
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0" style={{color: '#495057', fontWeight: '600'}}>Mensagem de aniversário</h6>
          <SelecionarWhatsapp tipo="InstanciaMensagemAniversario" onSuccess={onSuccess} onError={onError} />
        </div>
      </div>
      <div className="p-3">
        <div className="mb-3">
          <small className="text-muted d-block mb-2"><strong>Variáveis disponíveis:</strong></small>
          <Badge bg="light" text="dark" className="small">$nomePaciente</Badge>
        </div>
        
        <Row className="align-items-start mb-3">
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Tipo de mensagem</Form.Label>
            <Select
              value={{value: tipo, label: tipo}}
              onChange={(valor) => setTipo(valor.value)}
              options={[
                { value: "Texto", label: "Texto" },
                { value: "Imagem", label: "Imagem" }
              ]}
              styles={{
                control: (base) => ({
                  ...base,
                  fontSize: '13px',
                  minHeight: '32px'
                })
              }}
            />
          </Col>
          <Col md={7}>
            {tipo === 'Texto' ? (
              <div>
                <Form.Label className="small fw-medium text-muted">Mensagem de texto</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={textoConfiguracao}
                  onChange={(e) => setTextoConfiguracao(e.target.value)}
                  placeholder="Digite a mensagem de aniversário..."
                  style={{fontSize: '13px'}}
                />
              </div>
            ) : (
              <div>
                <Form.Label className="small fw-medium text-muted">Selecionar imagem</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  onChange={handleImageUpload}
                  style={{fontSize: '13px'}}
                />
                {imagemConfiguracao && (
                  <div className="mt-2">
                    <img 
                      src={imagemConfiguracao} 
                      alt="Preview" 
                      style={{height: '150px', width: '150px', objectFit: 'cover', borderRadius: '4px'}}
                    />
                  </div>
                )}
              </div>
            )}
          </Col>
          <Col md={2}>
            <Form.Label className="small fw-medium text-muted d-block">&nbsp;</Form.Label>
            <Button
              variant="success"
              size="sm"
              onClick={handleSalvar}
              disabled={loading}
              style={{backgroundColor: '#198754', borderColor: '#198754', fontSize: '13px', color: 'white'}}
            >
              {loading ? <Spinner size="sm" /> : 'Salvar'}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

// Componente para itens de configuração
const ConfiguracaoItem = ({ titulo, tipo, onSuccess, onError }) => {
  const [valor, setValor] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    pegarConfiguracao(tipo).then((dados) => {
      setValor(dados.valor || '');
    }).catch(erro => {
      console.error('Erro ao carregar configuração:', erro);
    });
  }, [tipo]);

  const handleSalvar = async () => {
    setLoading(true);
    try {
      await alterarConfiguracao(tipo, valor);
      onSuccess('Configuração salva com sucesso!');
    } catch (error) {
      onError('Erro ao salvar configuração.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row className="align-items-start mb-3">
      <Col md={3}>
        <Form.Label className="small fw-medium text-muted">{titulo}</Form.Label>
      </Col>
      <Col md={7}>
        <Form.Control
          as="textarea"
          rows={4}
          value={valor}
          onChange={(e) => setValor(e.target.value)}
          placeholder="Digite a mensagem..."
          style={{fontSize: '13px'}}
        />
      </Col>
      <Col md={2}>
        <Button
          variant="success"
          size="sm"
          onClick={handleSalvar}
          disabled={loading}
          style={{backgroundColor: '#198754', borderColor: '#198754', fontSize: '13px', color: 'white'}}
        >
          {loading ? <Spinner size="sm" /> : 'Salvar'}
        </Button>
      </Col>
    </Row>
  );
};

// Componente para seleção de WhatsApp
const SelecionarWhatsapp = ({ tipo, onSuccess, onError }) => {
  const [selecionado, setSelecionado] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    pegarClinicaConfiguracao(tipo).then((json) => {
      if (json && json.valor) {
        setSelecionado(json.valor);
      }
    }).catch(error => {
      console.error('Erro ao carregar configuração WhatsApp:', error);
    });
  }, [tipo]);

  const handleChange = async (valor) => {
    setLoading(true);
    try {
      await alterarConfiguracao(tipo, valor.value);
      setSelecionado(valor.value);
      onSuccess('Instância WhatsApp alterada com sucesso!');
    } catch (error) {
      onError('Erro ao alterar instância WhatsApp.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minWidth: '120px'}}>
      <Select
        value={{value: selecionado, label: `WhatsApp ${selecionado}`}}
        onChange={handleChange}
        options={[
          { value: 1, label: 'WhatsApp 1' },
          { value: 2, label: 'WhatsApp 2' },
          { value: 3, label: 'WhatsApp 3' },
          { value: 4, label: 'WhatsApp 4' }
        ]}
        isDisabled={loading}
        styles={{
          control: (base) => ({
            ...base,
            fontSize: '12px',
            minHeight: '28px'
          })
        }}
      />
    </div>
  );
};

export default MensagensView;